import { alpha } from '@mui/material'
import type { ThemeOptions } from '@mui/material/styles'

import type { ThemeColors } from '../types'

export const tableComponents = (colors: ThemeColors): ThemeOptions['components'] => ({
  MuiTable: {
    styleOverrides: {
      root: {
        fontFamily: 'var(--default-font)',
        fontFeatureSettings: '"tnum"',
      },
    },
  },
  MuiTableCell: {
    styleOverrides: {
      body: {
        fontSize: '1.6rem',
        paddingBottom: 8,
        paddingTop: 8,
      },
      footer: {
        borderBottomWidth: 0,
      },
      head: {
        borderBottomColor: colors.divider,
        color: colors.main[3],
        fontSize: '1.4rem',
        fontWeight: 600,
        height: 40,
      },
      paddingCheckbox: {
        '&:first-of-type': {
          padding: '0 18px',
          width: 72,
        },
        '&:last-of-type': {
          paddingRight: 20,
        },
        '&:not(first-of-type)': {
          padding: 0,
          width: 52,
        },
      },
      paddingNone: {
        '&&': {
          padding: 4,
        },
      },
      root: {
        '&:first-of-type': {
          '&.MuiTableCell-paddingCheckbox': {
            textOverflow: 'clip',
          },
          '&:not(.MuiTableCell-paddingCheckbox)': {
            paddingLeft: '24px',
            paddingRight: '24px',
            textAlign: 'left',
          },
        },
        borderBottomColor: alpha(colors.divider, 0.6),
        height: 44,
        overflow: 'hidden',
        padding: '6px 16px',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      },
    },
  },
  MuiTablePagination: {
    styleOverrides: {
      input: {
        color: colors.active[1],
        fontSize: '1.4rem',
      },
    },
  },
  MuiTableRow: {
    defaultProps: {
      hover: true,
    },
    styleOverrides: {
      footer: {
        '.MuiTableRow-root.MuiTableRow-hover&:hover': {
          background: 'none',
        },
      },
      head: {
        '.MuiTableRow-root.MuiTableRow-hover&:hover': {
          background: 'none',
        },
        color: colors.main[3],
      },
      root: {
        '&.Mui-selected, &.Mui-selected:hover': {
          backgroundColor: alpha(colors.active[1], 0.12),
        },
        '&.MuiTableRow-hover:hover': {
          backgroundColor: alpha(colors.active[1], 0.07),
        },
        position: 'relative',
      },
    },
  },
})
